module.exports = __webpack_public_path__ + "a16553d8003c1f6d99ae028cd4838271.svg";